module.exports = __webpack_public_path__ + "img/Steor-Icons-02.1780f405.svg";